module.exports = __webpack_public_path__ + "fonts/026f280096f1080ad4611bccb49a54c7.txt";